import React, { FC } from 'react';
import { DEFAULT_BACKGROUND_COLOR, DEFAULT_BACKGROUND_COLORS, mapNameToColour } from '../../../helpers/ColourMap';
import { replaceOrAddLocale, useLocale } from '../../../helpers/LangHelper';
import Icon, { IconType } from '../../icons';
import ImageZoom from '../../image-zoom/image-zoom';

import { IMAGE_POSITION, IMAGE_POSITIONS } from './b2b-framed-info-block.constants';

import styles from './b2b-framed-info-block.module.scss';
import { LazyBackgroundImage } from '@/components/lazy-background-image/lazy-background-image';

export type FramedInfoBlockProps = {
    borderColor?: DEFAULT_BACKGROUND_COLOR;
    image: string;
    title: string;
    description: string;
    url?: string;
    ctaText?: string;
    ctaIcon?: IconType;
    mediaPosition: IMAGE_POSITION;
};

const FramedInfoBlock: FC<FramedInfoBlockProps> = (props) => {
    const { locale } = useLocale();

    const { borderColor = DEFAULT_BACKGROUND_COLORS.MINT, image, title, description, mediaPosition = 'left', ctaText, ctaIcon } = props;
    let url = replaceOrAddLocale(props.url ?? '', locale);

    const mediaBlock = () => (
        <div className={`${styles.businessResourceBlockMediaContainer} ${styles[mediaPosition]}`}>
            <div className={styles.businessResourceBlockMedia}>
                <div className={`${styles.mediaImageWrapper} ${styles[mediaPosition]}`}>
                    <div className={styles.mediaImageBox}>
                        <div className={styles.mediaImageMain}>
                            <ImageZoom src={image} />
                        </div>
                    </div>
                </div>
                {/* <div className={`${styles.mediaBackground} ${styles[mediaPosition]}`} style={{ backgroundColor: mapNameToColour(borderColor) }}></div> */}
            </div>
        </div>
    );

    const infoBlock = () => (
        <div className={`${styles.businessResourceBlockInfo} ${styles[mediaPosition]}`}>
            <div className={styles.infoTitle} dangerouslySetInnerHTML={{ __html: title }}></div>
            <div className={styles.infoDescription} dangerouslySetInnerHTML={{ __html: description }}></div>

            <a href={url} className={styles.infoCTA}>
                <span>{ctaText ?? 'Download'}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                    <path
                        d="M13.7686 5.1286C14.1684 5.55168 14.3735 6.11577 14.3735 6.66902C14.3735 7.22228 14.1684 7.78637 13.7686 8.20944L9.36975 12.8633L7.92397 11.3337L11.3077 7.75384L0.0288087 7.75384L0.0288087 5.58421L11.2974 5.58421L7.92397 2.00433L9.36975 0.474699L13.7686 5.1286Z"
                        fill="white"
                    />
                </svg>
            </a>
        </div>
    );

    return (
        <div className={styles.businessResourceBlockContainer}>
            {mediaPosition === IMAGE_POSITIONS.LEFT ? mediaBlock() : null}
            {infoBlock()}
            {mediaPosition === IMAGE_POSITIONS.RIGHT ? mediaBlock() : null}
        </div>
    );
};

export default FramedInfoBlock;
